import React, { useState } from 'react'
import { deleteOrder } from 'src/features/OrdersCaptureSlice'
import { Checkbox, Button } from 'antd'
import ProductCard from '../ProductCard'
import AddProduct from '../AddProduct'

const RenderProducts = ({
  editedOmsOrders,
  newProducts,
  setNewProducts,
  selectedData,
  setSelectedData,
  setEditedOmsOrders,
  supplierProducts,
  handleRemoveProduct,
  handleAddProduct,
}) => {
  const [selectedProducts, setSelectedProducts] = useState([]) // Track selected products
  const [selectAll, setSelectAll] = useState(false)

  const handleOmsOrderChange = (index, field, value) => {
    const updatedOmsOrders = [...editedOmsOrders]
    updatedOmsOrders[index] = {
      ...updatedOmsOrders[index],
      [field]: value,
    }
    setEditedOmsOrders(updatedOmsOrders)
  }

  const handleOmsProductChange = (index, updatedProduct) => {
    setEditedOmsOrders(prevOrders => {
      const updatedOrders = [...prevOrders]
      updatedOrders[index] = updatedProduct
      return updatedOrders
    })
  }

  const toggleProductSelection = productId => {
    setSelectedProducts(prev =>
      prev.includes(productId)
        ? prev.filter(id => id !== productId)
        : [...prev, productId],
    )
  }

  const toggleSelectAll = () => {
    if (selectAll) {
      setSelectedProducts([])
    } else {
      const allProductIds = [
        ...editedOmsOrders.map(order => order._id),
        ...newProducts.map(product => product.id ?? product._id),
      ]
      setSelectedProducts(allProductIds)
    }
    setSelectAll(!selectAll)
  }

  const deleteSelectedProducts = async () => {
    const ordersToDelete = editedOmsOrders.filter(order =>
      selectedProducts.includes(order._id),
    )

    if (selectedData?.order) {
      const updatedOrderIds = selectedData.order.orderIds.filter(
        id => !ordersToDelete.some(order => order._id === id),
      )
      setSelectedData(prev => ({
        ...prev,
        order: {
          ...prev.order,
          orderIds: updatedOrderIds,
        },
      }))
    }
    await Promise.all(
      ordersToDelete.map(order =>
        deleteOrder(selectedData.order._id, order._id),
      ),
    )

    setEditedOmsOrders(prev =>
      prev.filter(order => !selectedProducts.includes(order._id)),
    )
    setNewProducts(prev =>
      prev.filter(
        product => !selectedProducts.includes(product.id ?? product._id),
      ),
    )

    setSelectedProducts([])
    setSelectAll(false)
  }

  const deleteAllProducts = async () => {
    if (selectedData?.order?.orderIds?.length > 0) {
      setSelectedData(prev => ({
        ...prev,
        order: {
          ...prev.order,
          orderIds: [],
        },
      }))

      await Promise.all(
        editedOmsOrders.map(order =>
          deleteOrder(selectedData.order._id, order._id),
        ),
      )

      setEditedOmsOrders([])
    }

    setNewProducts([])
    setSelectedProducts([])
    setSelectAll(false)
  }
  return (
    <div>
      <>
        <div
          style={{ display: 'flex', alignItems: 'center', marginBottom: 10 }}
        >
          <Checkbox
            checked={selectAll}
            onChange={toggleSelectAll}
            style={{ marginRight: 10 }}
          />
          <span>Select All</span>
          {selectedProducts.length > 0 && (
            <>
              <Button
                danger
                onClick={deleteSelectedProducts}
                style={{ marginLeft: 10 }}
              >
                Delete Selected ({selectedProducts.length})
              </Button>
              <Button
                danger
                onClick={deleteAllProducts}
                style={{ marginLeft: 10 }}
              >
                Delete All
              </Button>
            </>
          )}
        </div>
        {editedOmsOrders &&
          editedOmsOrders?.map((order, index) => (
            <div key={index} style={{ display: 'flex', alignItems: 'center' }}>
              <Checkbox
                checked={selectedProducts.includes(order._id)}
                onChange={() => toggleProductSelection(order._id)}
                style={{ marginRight: 10 }}
              />
              <ProductCard
                setSelectedData={setSelectedData}
                order={order}
                index={index}
                handleOmsOrderChange={handleOmsOrderChange}
                supplierProducts={supplierProducts}
                editedOmsOrders={editedOmsOrders}
                setEditedOmsOrders={setEditedOmsOrders}
                selectedData={selectedData}
                handleOmsProductChange={handleOmsProductChange}
              />
            </div>
          ))}

        {newProducts &&
          newProducts?.map((product, index) => (
            <div
              key={product.id ?? product._id}
              style={{ display: 'flex', alignItems: 'center' }}
            >
              <Checkbox
                checked={selectedProducts.includes(product.id ?? product._id)}
                onChange={() =>
                  toggleProductSelection(product.id ?? product._id)
                }
                style={{ marginRight: 10 }}
              />
              <AddProduct
                supplierProducts={supplierProducts}
                handleAddProduct={handleAddProduct}
                handleRemoveProduct={handleRemoveProduct}
                newProducts={newProducts}
                product={product}
                index={index}
              />
            </div>
          ))}
      </>
    </div>
  )
}

export default RenderProducts
